/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Herotitle1Inputs */

const he_extension_herotitle1 = /** @type {(inputs: Extension_Herotitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PriceDrop`)
};

const en_extension_herotitle1 = /** @type {(inputs: Extension_Herotitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PriceDrop`)
};

/**
* | output |
* | --- |
* | "PriceDrop" |
*
* @param {Extension_Herotitle1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_herotitle1 = /** @type {((inputs?: Extension_Herotitle1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Herotitle1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_herotitle1(inputs)
	return en_extension_herotitle1(inputs)
});
export { extension_herotitle1 as "extension_heroTitle" }